import * as R from 'ramda';
import { createSelector } from 'reselect';

import getPatient from '../getPatient';

export default createSelector(
  getPatient,

  R.propOr(false, 'custom_в_архив_1'),
);
